import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AboutApiService {

  private readonly aboutUrl: string = 'version';

  constructor(private http: HttpClient) {}

  public getAboutInformation(): Promise<any> {
    return this.http.get(this.aboutUrl).toPromise();
  }
}
